export default {
  socialLinks: {
    tiktok: 'https://www.tiktok.com/@thebracesguy',
    facebook: 'https://www.facebook.com/rochesterorthodontics',
    instagram: 'https://www.instagram.com/thebracesguy',
    blogger: 'https://rochesterorthodontics.blogspot.com/',
    google: 'https://plus.google.com/+CollinsOrthodonticsRochester/about',
    youtube: 'https://www.youtube.com/c/TheBracesGuyOfficial',
    spotify: 'https://CollinsMixedTape.com',
  },
}
